import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  courseList: [],
  courseFormList: [],
  courseDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchCourseList(state, action) {
      state.courseList = action.payload;
      state.loading = false;
    },
    fetchCourseFormList(state, action) {
      state.courseFormList = action.payload;
      state.loading = false;
    },
    fetchCourseDetail(state, action) {
      state.courseDetail = action.payload;
      state.loading = false;
    },
    fetchCourseFormListClear(state, action) {
      state.courseFormList = [];
      state.loading = false;
    },
  },
});

export const courseActions = courseSlice.actions;

export default courseSlice.reducer;
